import $ from 'jquery';
import {cloneObject} from './clone-object';
import {getViewportWidth} from './get-viewport-width';

/**
 * @function cfgManager
 * @description Managing configuration options
 *
 * @return {object}
 */

export const cfgManager = (defaults: any, cfg: any): {[key: string]: any} => {

  let output: {[key: string]: any} = {};

  const clonedDefaults = cloneObject(defaults);
  output = $.extend(clonedDefaults, cfg);

  // Save screen width
  const viewportWidth: number = getViewportWidth();

  if (typeof output.responsive === 'object') {
    $.each(output.responsive, (breakpoint: string, inheritCfg: any) => {
      const intBreakpoint: number = parseInt(breakpoint, 10);
      // If the breakpoint is a number.
      // And if the width of the browser is less than the breakpoint declared
      if (!isNaN(intBreakpoint) && viewportWidth >= intBreakpoint) {
        output = $.extend(output, inheritCfg);
      }
    });
  }

  return output;
};
